/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From 90 to 126: ((126 − 90) ÷ 90) × 100 = 40% increase.`)
};

const es_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 90 a 126: ((126 − 90) ÷ 90) × 100 = 40% de aumento.`)
};

const de_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von 90 auf 126: ((126 − 90) ÷ 90) × 100 = 40% Anstieg.`)
};

const nl_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van 90 naar 126: ((126 − 90) ÷ 90) × 100 = 40% stijging.`)
};

const fr_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 90 à 126 : ((126 − 90) ÷ 90) × 100 = augmentation de 40 %.`)
};

const it_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 90 a 126: ((126 − 90) ÷ 90) × 100 = aumento del 40%.`)
};

const pt_br2_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 90 para 126: ((126 − 90) ÷ 90) × 100 = 40% de aumento.`)
};

const pt_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 90 para 126: ((126 − 90) ÷ 90) × 100 = 40% de aumento.`)
};

const ja_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90から126へ: ((126 − 90) ÷ 90) × 100 = 40%増加。`)
};

const zh_pct_increase_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 90 到 126：((126 − 90) ÷ 90) × 100 = 增长 40%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_ex4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_ex4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_ex4", locale)
	if (locale === "en") return en_pct_increase_ex4(inputs)
	if (locale === "es") return es_pct_increase_ex4(inputs)
	if (locale === "de") return de_pct_increase_ex4(inputs)
	if (locale === "nl") return nl_pct_increase_ex4(inputs)
	if (locale === "fr") return fr_pct_increase_ex4(inputs)
	if (locale === "it") return it_pct_increase_ex4(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_ex4(inputs)
	if (locale === "pt") return pt_pct_increase_ex4(inputs)
	if (locale === "ja") return ja_pct_increase_ex4(inputs)
	return zh_pct_increase_ex4(inputs)
};